module.exports = __webpack_public_path__ + "static/img/footer-logo.a4f741c6.png";